import React, { Component } from 'react';


class TableCell extends Component {
    constructor(props) {
        super(props);

        this.handleClick = this.handleClick.bind(this);
    }

    handleClick(e) {
        if (e.target.checked) {
            this.props.onSelect();
        } else {
            this.props.onUnselect();
        }
    }

    render() {
        const { row, rowIndex, col, colIndex } = this.props;
        var returnType;

        if (rowIndex >= 0 && colIndex === 0) {
            returnType = <h6>{row}</h6>;
        } else if (rowIndex === 0 && colIndex > 0) {
            returnType = <h6>{col}</h6>;
        } else if (rowIndex >= 0 && colIndex >= 0) {
            returnType = <label className="radio-check">
                            <input value={colIndex} onChange={(e) => this.handleClick(e)} type="checkbox" />
                            <span></span>
                        </label>;
        } else {
            returnType = "";
        }

        return (
            <div>
                {returnType}
            </div>
        );
    }
}

export default TableCell;



// WEBPACK FOOTER //
// ./src/components/Membership/Step1/Skils&CompetencyTable/TableCell/index.js